// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../styles/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-bar {
	position: absolute;
	display: flex;
	align-items: flex-end;
    justify-content: flex-start;
	width: 240px;
	top: 0rem;
	bottom: unset;
	left: 0.5rem;
	z-index: 2000;
	-webkit-user-select: none;
	        user-select: none;
	pointer-events: none;
}
.color-bar-rect {
	width: 1.8rem;
	height: 1.8rem;
	position: relative;
}
.color-bar-wrapper {
	background-color: transparent;
	display: flex;
	flex-wrap: nowrap;
	-webkit-user-select: none;
	        user-select: none;
}
.color-bar-colors {
	display: flex;
	flex-direction: column;
	margin-top: 0.9rem;
	margin-bottom: 0.9rem;
	width: 2rem;
	z-index: 2001;
	border: 1px solid black;
	height: auto;
	max-height: fit-content;
	justify-content: center;
	pointer-events: all;
}
.color-bar-p p {
	text-align: left;
	justify-self: center;
	font-weight: 600;
}
.color-bar.left {
	bottom: unset;
	top: 0rem;
	right: unset;
	left: 0.5rem;
	flex-direction: row;
}
.color-bar.right {
	bottom: 3rem;
	left: unset;
	right: 0.5rem;
	flex-direction: row-reverse;
}
.color-bar-texts {
	display: flex;
	flex-direction: column;
	justify-content: center;
	pointer-events: all;
}
.color-bar-texts p {
	font-family: "Inter-Bold", sans-serif;
	font-weight: 600;
	text-align: center;
	text-justify: center;
}
.color-bar-p {
	width: 1.8rem;
	height: 1.8rem;
	display: flex;
	align-items: center;
	align-content: center;
	text-align: left;
	font-weight: 600;
	margin-left: 0.5rem;
}
.color-bar.right .color-bar-wrapper {
	display: flex;
	justify-content: right;
}
.color-bar.left .color-bar-wrapper {
	display: flex;
	align-content: flex-start;
	align-items: center;
}
.color-bar.left .color-bar-texts {
	align-items: flex-end;
}
.color-bar.right .color-bar-texts {
	align-items: flex-start;
}
.color-bar.left .color-bar-colors {
	flex-grow: 0;
}
.color-bar.right .color-bar-colors {
	flex-grow: 0;
}
.color-bar.right .color-bar-p {
	width: 100%;
	text-align: right;
	margin-left: unset;
	margin-right: 0.5rem;
	justify-content: right;
}
.color-bar.left .color-bar-p {
	width: 100%;
	text-align: left;
	margin-left: 0.5rem;
	margin-right: unset;
	justify-content: left;
}
.color-bar.right .color-bar-p p {
	text-align: right;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	align-self: right;
	margin-right: 0.5rem;
}
.color-bar.left .color-bar-p p {
	text-align: left;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	align-self: left;
	margin-left: 0.5rem;
}

@keyframes fadeOut {
	from {
	  opacity: 1;
	}
	to {
	  opacity: 0;
	}
  }

.tile-name-wrapper {
	padding: 0;
	min-width: 165px;
	margin-left: 15px;
	margin-right: 15px;
	margin-bottom: 5px;
	background-color: transparent;
	border-radius: 0px;
	font-size: 0.8rem;
	font-weight: bold;
	color: var(--primary-color1);
	font-family: "Inter-Bold", sens-serif;
	font-weight: bold;
	pointer-events: none;
	z-index: 5000;
	opacity: 1;
	transition: opacity 1s ease;
}
.tile-name-wrapper.faded {
	opacity: 0;
}
.color-bar-wrapper:hover ~ .tile-name-wrapper {
	opacity: 1;
}
.tile-name-wrapper p {
	font-size: 1.2rem;
}
.tile-name-wrapper .left p {
	text-align: left;
}
.tile-name-wrapper .right p {
	text-align: right;
}

@media (min-width: 500px) {
	.color-bar {
		top: unset;
		bottom: 0rem;
		left: 1rem;
	}
	.color-bar-colors {
		height: 100%;
	}
	.color-bar-texts p {
		text-align: left;
		justify-self: center;
	}
	.color-bar-p {
		width: 11rem;
	}
	.color-bar-p p {
		text-align: left;
		justify-self: center;
		font-weight: 600;
	}
	.color-bar.right {
		bottom: 0rem;
		left: unset;
		right: 0.5rem;
	}
	.color-bar.left {
		top: unset;
		bottom: 0rem;
		right: unset;
		left: 0.5rem;
	}

	.tile-name-wrapper p {
		font-size: 1.4rem;
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/map/ColorBarLabel/ColorBarLabelComponent.css"],"names":[],"mappings":"AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,qBAAqB;IAClB,2BAA2B;CAC9B,YAAY;CACZ,SAAS;CACT,aAAa;CACb,YAAY;CACZ,aAAa;CACb,yBAAiB;SAAjB,iBAAiB;CACjB,oBAAoB;AACrB;AACA;CACC,aAAa;CACb,cAAc;CACd,kBAAkB;AACnB;AACA;CACC,6BAA6B;CAC7B,aAAa;CACb,iBAAiB;CACjB,yBAAiB;SAAjB,iBAAiB;AAClB;AACA;CACC,aAAa;CACb,sBAAsB;CACtB,kBAAkB;CAClB,qBAAqB;CACrB,WAAW;CACX,aAAa;CACb,uBAAuB;CACvB,YAAY;CACZ,uBAAuB;CACvB,uBAAuB;CACvB,mBAAmB;AACpB;AACA;CACC,gBAAgB;CAChB,oBAAoB;CACpB,gBAAgB;AACjB;AACA;CACC,aAAa;CACb,SAAS;CACT,YAAY;CACZ,YAAY;CACZ,mBAAmB;AACpB;AACA;CACC,YAAY;CACZ,WAAW;CACX,aAAa;CACb,2BAA2B;AAC5B;AACA;CACC,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;AACpB;AACA;CACC,qCAAqC;CACrC,gBAAgB;CAChB,kBAAkB;CAClB,oBAAoB;AACrB;AACA;CACC,aAAa;CACb,cAAc;CACd,aAAa;CACb,mBAAmB;CACnB,qBAAqB;CACrB,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,aAAa;CACb,sBAAsB;AACvB;AACA;CACC,aAAa;CACb,yBAAyB;CACzB,mBAAmB;AACpB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,uBAAuB;AACxB;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,WAAW;CACX,iBAAiB;CACjB,kBAAkB;CAClB,oBAAoB;CACpB,sBAAsB;AACvB;AACA;CACC,WAAW;CACX,gBAAgB;CAChB,mBAAmB;CACnB,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,mBAAmB;CACnB,uBAAuB;CACvB,iBAAiB;CACjB,oBAAoB;AACrB;AACA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC;GACE,UAAU;CACZ;CACA;GACE,UAAU;CACZ;EACC;;AAEF;CACC,UAAU;CACV,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,6BAA6B;CAC7B,kBAAkB;CAClB,iBAAiB;CACjB,iBAAiB;CACjB,4BAA4B;CAC5B,qCAAqC;CACrC,iBAAiB;CACjB,oBAAoB;CACpB,aAAa;CACb,UAAU;CACV,2BAA2B;AAC5B;AACA;CACC,UAAU;AACX;AACA;CACC,UAAU;AACX;AACA;CACC,iBAAiB;AAClB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB;;AAEA;CACC;EACC,UAAU;EACV,YAAY;EACZ,UAAU;CACX;CACA;EACC,YAAY;CACb;CACA;EACC,gBAAgB;EAChB,oBAAoB;CACrB;CACA;EACC,YAAY;CACb;CACA;EACC,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;CACjB;CACA;EACC,YAAY;EACZ,WAAW;EACX,aAAa;CACd;CACA;EACC,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD","sourcesContent":["@import url(\"styles/colors.css\");\n\n.color-bar {\n\tposition: absolute;\n\tdisplay: flex;\n\talign-items: flex-end;\n    justify-content: flex-start;\n\twidth: 240px;\n\ttop: 0rem;\n\tbottom: unset;\n\tleft: 0.5rem;\n\tz-index: 2000;\n\tuser-select: none;\n\tpointer-events: none;\n}\n.color-bar-rect {\n\twidth: 1.8rem;\n\theight: 1.8rem;\n\tposition: relative;\n}\n.color-bar-wrapper {\n\tbackground-color: transparent;\n\tdisplay: flex;\n\tflex-wrap: nowrap;\n\tuser-select: none;\n}\n.color-bar-colors {\n\tdisplay: flex;\n\tflex-direction: column;\n\tmargin-top: 0.9rem;\n\tmargin-bottom: 0.9rem;\n\twidth: 2rem;\n\tz-index: 2001;\n\tborder: 1px solid black;\n\theight: auto;\n\tmax-height: fit-content;\n\tjustify-content: center;\n\tpointer-events: all;\n}\n.color-bar-p p {\n\ttext-align: left;\n\tjustify-self: center;\n\tfont-weight: 600;\n}\n.color-bar.left {\n\tbottom: unset;\n\ttop: 0rem;\n\tright: unset;\n\tleft: 0.5rem;\n\tflex-direction: row;\n}\n.color-bar.right {\n\tbottom: 3rem;\n\tleft: unset;\n\tright: 0.5rem;\n\tflex-direction: row-reverse;\n}\n.color-bar-texts {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\tpointer-events: all;\n}\n.color-bar-texts p {\n\tfont-family: \"Inter-Bold\", sans-serif;\n\tfont-weight: 600;\n\ttext-align: center;\n\ttext-justify: center;\n}\n.color-bar-p {\n\twidth: 1.8rem;\n\theight: 1.8rem;\n\tdisplay: flex;\n\talign-items: center;\n\talign-content: center;\n\ttext-align: left;\n\tfont-weight: 600;\n\tmargin-left: 0.5rem;\n}\n.color-bar.right .color-bar-wrapper {\n\tdisplay: flex;\n\tjustify-content: right;\n}\n.color-bar.left .color-bar-wrapper {\n\tdisplay: flex;\n\talign-content: flex-start;\n\talign-items: center;\n}\n.color-bar.left .color-bar-texts {\n\talign-items: flex-end;\n}\n.color-bar.right .color-bar-texts {\n\talign-items: flex-start;\n}\n.color-bar.left .color-bar-colors {\n\tflex-grow: 0;\n}\n.color-bar.right .color-bar-colors {\n\tflex-grow: 0;\n}\n.color-bar.right .color-bar-p {\n\twidth: 100%;\n\ttext-align: right;\n\tmargin-left: unset;\n\tmargin-right: 0.5rem;\n\tjustify-content: right;\n}\n.color-bar.left .color-bar-p {\n\twidth: 100%;\n\ttext-align: left;\n\tmargin-left: 0.5rem;\n\tmargin-right: unset;\n\tjustify-content: left;\n}\n.color-bar.right .color-bar-p p {\n\ttext-align: right;\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\talign-self: right;\n\tmargin-right: 0.5rem;\n}\n.color-bar.left .color-bar-p p {\n\ttext-align: left;\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\talign-self: left;\n\tmargin-left: 0.5rem;\n}\n\n@keyframes fadeOut {\n\tfrom {\n\t  opacity: 1;\n\t}\n\tto {\n\t  opacity: 0;\n\t}\n  }\n\n.tile-name-wrapper {\n\tpadding: 0;\n\tmin-width: 165px;\n\tmargin-left: 15px;\n\tmargin-right: 15px;\n\tmargin-bottom: 5px;\n\tbackground-color: transparent;\n\tborder-radius: 0px;\n\tfont-size: 0.8rem;\n\tfont-weight: bold;\n\tcolor: var(--primary-color1);\n\tfont-family: \"Inter-Bold\", sens-serif;\n\tfont-weight: bold;\n\tpointer-events: none;\n\tz-index: 5000;\n\topacity: 1;\n\ttransition: opacity 1s ease;\n}\n.tile-name-wrapper.faded {\n\topacity: 0;\n}\n.color-bar-wrapper:hover ~ .tile-name-wrapper {\n\topacity: 1;\n}\n.tile-name-wrapper p {\n\tfont-size: 1.2rem;\n}\n.tile-name-wrapper .left p {\n\ttext-align: left;\n}\n.tile-name-wrapper .right p {\n\ttext-align: right;\n}\n\n@media (min-width: 500px) {\n\t.color-bar {\n\t\ttop: unset;\n\t\tbottom: 0rem;\n\t\tleft: 1rem;\n\t}\n\t.color-bar-colors {\n\t\theight: 100%;\n\t}\n\t.color-bar-texts p {\n\t\ttext-align: left;\n\t\tjustify-self: center;\n\t}\n\t.color-bar-p {\n\t\twidth: 11rem;\n\t}\n\t.color-bar-p p {\n\t\ttext-align: left;\n\t\tjustify-self: center;\n\t\tfont-weight: 600;\n\t}\n\t.color-bar.right {\n\t\tbottom: 0rem;\n\t\tleft: unset;\n\t\tright: 0.5rem;\n\t}\n\t.color-bar.left {\n\t\ttop: unset;\n\t\tbottom: 0rem;\n\t\tright: unset;\n\t\tleft: 0.5rem;\n\t}\n\n\t.tile-name-wrapper p {\n\t\tfont-size: 1.4rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
